<template>
  <div
    class="requirements-list-area bg-gray section-space--ptb_150"
    id="requirement"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="row justify-content-center">
          <h2 class="requirements-list__title mb-15 wow move-up">
            {{ pageTitle }}
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "requireList",
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
  computed: {
    // handle multi routes title translation and showing
    pageTitle() {
      if (this.$route.name.includes("Industrial"))
        return this.i18n("industrial.title");
      if (this.$route.name.includes("Fish")) return this.i18n("fish.title");
      if (this.$route.name.includes("Marine")) return this.i18n("marine.title");
      if (this.$route.name.includes("Oil")) return this.i18n("oil.title");
      if (this.$route.name.includes("Pumps")) return this.i18n("pump.title");
    },
  },
};
</script>
<style scoped>
/* .col-lg-12{ */
/* align-items: center; */
/* } */
.requirements-list__title {
  color: white;
}
</style>
